import {containerWidths} from '../constants/containerWidths';

export const getBookSectionSlideCSS = (fontSize = 12) => `
    .content {
      overflow-y: auto;
    }
    .standby-content-container {
      box-sizing: border-box;
      max-width: ${containerWidths.maxWidthContainer}px;
      font-family: InterUI-Regular, -apple-system, BlinkMacSystemFont,
                  "Segoe UI", "Roboto", "Oxygen",
                  "Ubuntu", "Cantarell", "Fira Sans",
                  "Droid Sans", "Helvetica Neue", sans-serif;
      font-size: ${fontSize}px;
      margin-top:1em;
      margin-left:auto;
      margin-right:auto;
      padding-left: 16px;
      padding-right: 16px;
      padding-bottom: 16px;
      -webkit-text-size-adjust:none;
      /*    6.5 inch*/

      overflow-wrap: break-word;
      word-wrap: break-word;
      -ms-word-break: break-all;
      word-break: break-word;
    }
    .chapterTitle {
      font-size: 12px;
      color: #212529;
    }
    body, html, .height-calculator {
      margin: 0;
      padding: 0;
    }
    .height-calculator {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
    }
    .hiddenText {
      display: none;
    }
    img {
      max-width: 100%;
    }
    .searchHighlight {
      background-color: #E5F1FF;
      color: black;
      display: inline;
    }
    .searchHighlightCurrent {
      background-color: #007BFE;
      color: white;
      display: inline;
    }
    h3 {
      font-size: 22px !important;
      font-weight: bold !important;
      color: #212529 !important;
    }
    .bookReadTitleLabel {
      font-weight: 700;
      text-align: center;
      margin-bottom: 10px;
    }
    .bookReadButton {
      font-weight: 700;
      color: #1581ea;
      background-color: #fff;
      border: 1px solid #1581ea;
      padding-top: 13px;
      padding-bottom: 13px;
      text-align: center;
      max-width: 342px;
      margin: auto;
      margin-bottom: 20px;
      border-radius: 8px;
    }
    .bookQuizLabel {
      font-weight: 700;
      text-align: center;
      margin-bottom: 10px;
    }
    .bookQuizButton {
      font-weight: 700;
      color: #fff;
      background-color: #1581ea;
      border: 1px solid #1581ea;
      padding-top: 13px;
      padding-bottom: 13px;
      text-align: center;
      max-width: 342px;
      margin: auto;
      margin-bottom: 20px;
      border-radius: 8px;
    }
    .bookParaFolioButton {
      font-weight: 700;
      color: #FFF;
      background-color: #1581ea;
      padding-top: 13px;
      padding-bottom: 13px;
      text-align: center;
      max-width: 342px;
      margin: auto;
      margin-bottom: 20px;
      border-radius: 8px;
    }
    .bookButtonsContainer {
      margin-top: 15px;
    }
`;
